/*eslint react/style-prop-object:0*/
import React from "react";

import "./MapComponent.scss";
import { Marker, Path, StaticGoogleMap } from "react-static-google-map";
import { keys } from "../../globals.js";

const googleApiKey = keys.googleApi;
/*global google*/

export default class MapComponent extends React.Component {
  state = {
    pathHasBeenReturned: false,
    fetchingDireections: false,
  };

  componentDidUpdate = () => {
    if (
      this.state.pathHasBeenReturned === false &&
      this.state.fetchingDireections === false
    ) {
      if (
        window.google &&
        this.props.pickupPlace.lat &&
        this.props.dropoffPlace?.lat
      ) {
        let directionsService = new google.maps.DirectionsService();
        let directionsRequest = {
          origin: {
            lat: this.props.pickupPlace.lat,
            lng: this.props.pickupPlace.lng,
          },
          destination: {
            lat: this.props.dropoffPlace?.lat,
            lng: this.props.dropoffPlace?.lng,
          },
          travelMode: "DRIVING",
        };
        const localSelf = this;
        directionsService.route(directionsRequest, function (result, status) {
          if (
            status === "OK" &&
            result &&
            result.routes &&
            typeof result.routes === "object"
          ) {
            localSelf.setState({
              pathHasBeenReturned: `enc:${result.routes[0].overview_polyline}`,
            });
          } else {
            console.log("error fetching directions");
          }
        });
      }
    }
  };

  render() {
    return (
      <div className={"mapContainer"}>
        <StaticGoogleMap
          scale={2}
          size="800x480"
          apiKey={googleApiKey}
          style={
            "feature:administrative|element:labels.text.fill|color:0x444444&style=feature:administrative.locality|element:geometry.fill|visibility:off|color:0xc44242&style=feature:administrative.neighborhood|element:geometry.fill|visibility:off|color:0x4f5d77&style=feature:administrative.neighborhood|element:labels.text.fill|visibility:on|color:0x4f5d77&style=feature:administrative.neighborhood|element:labels.text.stroke|color:0xbcc9e2|visibility:off|saturation:-24|gamma:1.19|weight:0.75&style=feature:landscape|element:all|color:0xf2f2f2&style=feature:landscape|element:geometry.fill|color:0xfafafb&style=feature:landscape|element:geometry.stroke|color:0x62696c|visibility:off&style=feature:landscape.man_made|element:geometry.fill|color:0xdce9ff|visibility:on|saturation:8|lightness:36|gamma:1.18&style=feature:poi|element:all|visibility:off&style=feature:poi.attraction|element:geometry.fill|color:0xdf5526|visibility:off&style=feature:poi.business|element:geometry.fill|color:0xdf5526|visibility:off&style=feature:poi.business|element:labels.icon|visibility:on|hue:0xff7d00&style=feature:poi.park|element:geometry.fill|visibility:on|color:0xd0ebd0&style=feature:road|element:all|saturation:-100|lightness:45|hue:0xff00fb|visibility:on&style=feature:road.highway|element:all|visibility:simplified&style=feature:road.highway|element:geometry.fill|color:0xdce9ff|visibility:on|saturation:-4&style=feature:road.highway|element:geometry.stroke|visibility:on|color:0xffb79c|weight:1.30|lightness:46&style=feature:road.arterial|element:labels.text.fill|color:0x4f5d77&style=feature:road.arterial|element:labels.icon|visibility:off&style=feature:road.local|element:geometry.fill|visibility:on|hue:0xff0000&style=feature:road.local|element:labels.text|visibility:off|color:0xff0000&style=feature:road.local|element:labels.text.fill|visibility:on|color:0x4c5559&style=feature:road.local|element:labels.text.stroke|hue:0xff0000&style=feature:transit|element:all|visibility:off&style=feature:water|element:all|color:0xbfa9bf|visibility:on&style=feature:water|element:geometry.fill|color:0xa6b6d5|lightness:-5|gamma:1.00|saturation:-18&style=feature:water|element:labels.text.fill|visibility:on|color:0xffffff"
          }
        >
          <Marker
            size={"small"}
            scale={2}
            iconURL={
              "https://assets.s3.amazonaws.com/images/front-end/pickupLocationMarker.png"
            }
            location={{
              lat: this.props.pickupPlace.lat,
              lng: this.props.pickupPlace.lng,
            }}
          />
          <Marker
            size={"small"}
            scale={2}
            iconURL={
              "https://assets.s3.amazonaws.com/images/front-end/dropoffLocationMarker.png"
            }
            location={{
              lat: this.props.dropoffPlace?.lat,
              lng: this.props.dropoffPlace?.lng,
            }}
          />

          <Path
            weight="8"
            color="0xDF5526ff"
            points={
              this.state.pathHasBeenReturned
                ? this.state.pathHasBeenReturned
                : [
                    `${this.props.pickupPlace.lat}, ${this.props.pickupPlace.lng}`,
                    `${this.props.dropoffPlace?.lat}, ${this.props.dropoffPlace?.lng}`,
                  ]
            }
          />
        </StaticGoogleMap>
      </div>
    );
  }
}
